module.exports = __webpack_public_path__ + "img/bg-large.dd9648c2.png";